import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import authInterceptor from './utils/authInterceptor';

import Header from './components/DynamicHeader';
import RouteTracker from './components/RouteTracker';
import Home from './components/Home/Home';
import Pricing from './components/Pricing/Pricing';
import AboutUs from './components/AboutUs/AboutUs';
import ContactUs from './components/ContactUs/ContactUs';
import AuthSwitch from './components/Login-SignUp/AuthSwitch';
import OngVerification from './components/Login-SignUp/OngVerification';
import Pin from './components/Login-SignUp/Pin';
import Welcome from './components/Login-SignUp/WelcomePin';
import Choose from './components/Admin-/Choose';
import Dashboard from './components/Admin-/Dashboard';
import SurveyDetail from './components/Admin-/SurveyDetail';
import PrivacyPolicy from './components/PrivacyPolicy';
import { SurveyProvider } from './assets/js/SurveyContext';
import { TemplateProvider } from './assets/js/TemplateContext';
import { ThemeProvider } from './assets/js/ThemeContext';
import NotificationsPage from './components/Admin-/NotificationsPage';
import Restore from './components/Login-SignUp/restore';
import GoogleSignup from './components/Login-SignUp/GoogleSignup';
import OAuthCallback from './components/Login-SignUp/OAuthCallback';

import SubscriptionOptions from './components/SubscriptionOptions';
import SuccessPage from './components/Check/SuccessPage';
import CancelPage from './components/Check/CancelPage';

import ProfileEditor from './components/Admin-/ProfileEditor';
import Admin from './components/Admin';



import DiscountCodes from './components/Admin-/DiscountCodes';
import ScrollToTopButton from './components/common/ScrollToTopButton';
import CookieBanner from './components/common/CookieBanner';
import ScrollToTop from './components/common/ScrollToTop';

import { GoogleOAuthProvider } from '@react-oauth/google';
import ShapeChat from './components/ShapeChat';
import AiDocuments from './components/Admin-/AiDocuments';
import NotFound from './components/NotFound';
import PinOrNotFound from './components/PinOrNotFound';
import ErrorBoundary from './components/common/ErrorBoundary';
import './App.css';
import './assets/styles/tokens.css';
import './assets/styles/Theme.css';
import { useLanguage } from './assets/js/LanguageContext';

// Un error al dibujar una página enseña un aviso en lugar de la pantalla en blanco; el menú sigue en pie
// y al navegar a otra dirección se vuelve a intentar.
const PageErrorBoundary = ({ children }) => {
    const { pathname } = useLocation();
    return <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>;
};

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    const { language } = useLanguage();

    useEffect(() => {
        authInterceptor.init();

        const handleAuthChange = () => {
            setIsAuthenticated(!!localStorage.getItem('token'));
        };

        window.addEventListener('authChange', handleAuthChange);

        return () => {
            window.removeEventListener('authChange', handleAuthChange);
            authInterceptor.cleanup();
        };
    }, []);

    return (
        <GoogleOAuthProvider clientId="477110382914-dkhnh97th3jkvv54cvkivpum73f065bp.apps.googleusercontent.com">
        <Router>
            <ThemeProvider>
                <SurveyProvider>
                    <TemplateProvider>
                        <div className="App">
                            <RouteTracker />
                            <ScrollToTop />
                            <Header />
                            <PageErrorBoundary>
                            <Routes key={language}>
                                <Route path="/" element={<Home />} />
                                <Route path="/pricing" element={<Pricing />} />
                                <Route path="/about-us" element={<AboutUs />} />
                                <Route path="/contact-us" element={<ContactUs />} />
                                <Route element={<AuthSwitch />}>
                                    <Route path="/login" element={null} />
                                    <Route path="/sign-up" element={null} />
                                </Route>
                                <Route path="/ong-verification" element={<OngVerification />} />
                                <Route path="/reset-password" element={<Restore />} />
                                <Route path="/google-signup" element={<GoogleSignup />} />
                                <Route path="/oauth/callback" element={<OAuthCallback />} />

                                <Route path="/subscribe" element={<SubscriptionOptions />} />
                                <Route path="/success" element={<SuccessPage />} />
                                <Route path="/cancel" element={<CancelPage />} />

                                <Route path="/pin" element={<Pin />} />
                                <Route path="/welcome" element={<Welcome />} />
                                <Route path="/:pin" element={<PinOrNotFound />} />
                                <Route path="/choose" element={
                                    isAuthenticated ? <Choose /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/dashboard" element={
                                    isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/dashboard/:id" element={
                                    isAuthenticated ? <SurveyDetail /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/notifications" element={
                                    isAuthenticated ? <NotificationsPage /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/discount-codes" element={
                                    isAuthenticated ? <DiscountCodes /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/profile" element={
                                    isAuthenticated ? <ProfileEditor /> : <Navigate to="/login" replace />
                                } />
				 <Route path="/admin" element={
                                    isAuthenticated ? <Admin /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/ai-documents" element={
                                    isAuthenticated ? <AiDocuments /> : <Navigate to="/login" replace />
                                } />
                                <Route path="/privacy" element={<PrivacyPolicy />} />
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                            </PageErrorBoundary>
                            <ScrollToTopButton />
                            <CookieBanner />
                            <ShapeChat isAuthenticated={isAuthenticated} />
                        </div>
                    </TemplateProvider>
                </SurveyProvider>
            </ThemeProvider>
        </Router>
        </GoogleOAuthProvider>
    );
}

export default App;
